import Translation from '../../../../Shared/components/Translation';
import { ZdsButton } from '@zig-design-system/ui-components-react';
import React, { useContext } from 'react';
import { RootContext } from '../../../../Context/RootContext';
import Alert, { AlertType } from '../../../../Shared/components/Alert';
const Reaction = ({ complex }) => {
    const pluginContext = useContext(RootContext).pluginContext;
    if (!pluginContext.reactionPageComplex) {
        return null;
    }
    let linkUrl = null;
    try {
        const params = new URLSearchParams({ name: complex.name });
        if (complex.complexNumber) {
            params.append('complexNumber', complex.complexNumber);
        }
        if (complex.city) {
            params.append('city', complex.city);
        }
        linkUrl = new URL(pluginContext.reactionPageComplex);
        linkUrl.search = params.toString();
    }
    catch (e) {
        return (React.createElement("div", { className: "zds-margin-top-6 md:zds-margin-top-0" },
            React.createElement(Alert, { type: AlertType.error, message: React.createElement(Translation, { item: "tx_zigrealestate.error.urlNotValid", asString: true }) })));
    }
    if (linkUrl) {
        return (React.createElement("div", { className: "zds-margin-top-6 md:zds-margin-top-0" },
            React.createElement(ZdsButton, { size: "lg", link: linkUrl.href, linkTarget: linkUrl.hostname !== window.location.host ? '_blank' : '_self' },
                React.createElement(Translation, { item: "tx_zigrealestate.detail.respond" }))));
    }
};
export default Reaction;
